import { ClerkProvider, SignedIn, SignedOut, RedirectToSignIn, useUser } from '@clerk/clerk-react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import DailyTracking from './pages/DailyTracking'
import ErrorBook from './pages/ErrorBook'
import ReviewQueue from './pages/ReviewQueue'
import Review from './pages/Review'
import { AuthCard } from './components/Auth'

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!clerkPubKey) {
  console.warn('Missing VITE_CLERK_PUBLISHABLE_KEY. Please set it in .env.local')
}

function AppRoutes() {
  const { user } = useUser()

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route
          index
          element={
            <ProtectedRoute>
              <Dashboard userId={user?.id} />
            </ProtectedRoute>
          }
        />
        <Route
          path="tracking"
          element={
            <ProtectedRoute>
              <DailyTracking userId={user?.id} />
            </ProtectedRoute>
          }
        />
        <Route
          path="error-book"
          element={
            <ProtectedRoute>
              <ErrorBook userId={user?.id} />
            </ProtectedRoute>
          }
        />
        <Route
          path="review-queue"
          element={
            <ProtectedRoute>
              <ReviewQueue userId={user?.id} />
            </ProtectedRoute>
          }
        />
        <Route
          path="review"
          element={
            <ProtectedRoute>
              <Review userId={user?.id} />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/login" element={<AuthCard />} />
    </Routes>
  )
}

function ProtectedRoute({ children }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  )
}

export default function App() {
  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ClerkProvider>
  )
}
